import Navbar from '../components/Navbar';
import { FaBan, FaExclamationTriangle } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from '../hooks';
import { useEffect, useState } from 'react';
import { getConfig } from '../features/Sensors/ConfigSlice';
import IShipsConfig from '../interfaces/config.interface';
import IMeasurement from '../interfaces/measurement.interface';
import Sensor from '../components/Sensor';
import Button from '../components/Button';
import PageContainer from '../components/containers/PageContainer';
import PopupSensorTable from '../components/PopupSensorTable';

type HeaderFields = {
  [key: string]: string;
};

type TableRow = {
  [key: string]: string;
};

const tableHeaders: HeaderFields[] = [
  { definition: 'definition', comment: 'comment', IP: 'IP', Port: 'Port', Interval: 'Interval' },

];
const tableRows: TableRow[] = [
  { definition: 'This is a test message', comment: 'Made by Kevin', IP: '192.168.178.12', Port: '9023', Interval: '2s' },
  { definition: 'GPS SIGNAL IS {Seapath.INGGA.lat}, {Seapath.INGGA.lon}', comment: 'Iakovos GPS logger', IP: '192.168.178.13', Port: '440001', Interval: '1s' },
]




export default function Sensors() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useAppDispatch()
  const measurements = useAppSelector(state => state.Measurements.measurements);
  useEffect(() => {
    

  }, [])
  const shipsconfig: IShipsConfig | undefined = useAppSelector(state => state.Config.shipsconfig);
  return (
    <>
      <Navbar />
      <PageContainer title='Sensors'>
        <div className="sensor-top-bar flex bot-gap">
          <div className="dotted-line flex justify-between align-center">
            <p>Valid</p>
            <p className='goldenrod flex justify-between gap-1'>Unreliable <FaExclamationTriangle /></p>
            <p className='red-frequency flex justify-between gap-1'>Invalid <FaBan /></p>
          </div>
          <Button
            label={collapsed ? "Expand all" : "Collapse all"}
            width='fit'
            onClick={() => setCollapsed(!collapsed)}
          />
        </div>
        <div className="sensor-grid grid gap-1">
          {shipsconfig?.instruments?.map((device, deviceIndex) => (
            device.sensors.map((sensorObj, sensorIndex) => (
              <Sensor
                key={`${deviceIndex}-${sensorIndex}`}
                frequency={sensorObj.frequency}
                sensorName={sensorObj.id}
                deviceName={device.name}
                sensorData={sensorObj.parameters}
                collapsed={collapsed}
              />
            ))
          ))}
        </div>
        {/* <PopupSensorTable /> */}
      </PageContainer>
    </>
    // <div className='flex h-full w-full'>
    //   <Navbar />
    //   <div className="w-2/12"></div>
    //   <div className='page relative' id="page-wrapper">
    //     <StatusBar />
    //     <div className="mob-blocks max-w-full px-2 pt-2">
    //       <div className='page_header'>
    //         <h2 className='text-3xl'>Sensors</h2>
    //       </div>
    //       <div className='dark:bg-nred bg-nwhite flex items-center justify-between px-2 bg-white border-b-4 border-dotted border-black'>
    //         <p className='flex items-center'>Valid</p> <p className='flex items-center text-yellow-500'>Unreliable <FaExclamationTriangle /></p> <p className='flex items-center text-red-500'>Invalid<FaBan /></p>
    //       </div>
    //       <div className='flex items-center'>
    //         <button onClick={expandTables}>Expand All</button>
    //         <p className='px-2'>/</p>
    //         <button onClick={collapseTables}>Collapse All </button>
    //       </div>
    //     </div>
    //     <div className="desktop-blocks w-full h-full p-5">
    //       <div className='page_header'>
    //         <h2 className='text-3xl'>Sensors</h2>
    //         <p className=''></p>
    //       </div>
    //       <div className='dark:bg-nred bg-nwhite flex items-center justify-between px-2 bg-white border-b-4 border-dotted border-black'>
    //         <p className='flex items-center'>Valid</p> <p className='flex items-center goldenrod'>Unreliable <FaExclamationTriangle /></p> <p className='flex items-center text-red-500'>Invalid<FaBan /></p>
    //       </div>
    //       <div className='flex items-center'>
    //         <button onClick={expandTables}>Expand All</button>
    //         <p className='px-2'>/</p>
    //         <button onClick={collapseTables}>Collapse All</button>
    //       </div>
    //       <div className='grid grid-cols-4 gap-4'>
    //         {shipsconfig?.instruments?.map((item, index) => (
    //           <div className="sensor_block overflow-hidden" key={index}>
    //             <SensorHeader cross={2} calibration="" title={item.name} />
    //             <table className='data-table w-full'>
    //               <tbody>
    //                 {item.sensors?.map((sensor) => (
    //                   sensor.parameters.map((parameter) => (
    //                     <tr key={parameter.id}>
    //                       <td>{parameter.column}</td>
    //                       <td className={checkTimestampStatus( (getByPath(item.name + '.' + sensor.id + '.' + parameter.column, measurements)?.timestamp), sensor.frequency )}>{getByPath(item.name + '.' + sensor.id + '.' + parameter.column, measurements)?.value}</td>
    //                     </tr>
    //                   ))
    //                 ))}
    //               </tbody>
    //             </table>
    //           </div>
    //         ))
    //         }
    //       </div>
    //     </div>
    //     <OpenButton text='+' styleClasses='bg-nblue rounded-full px-4 py-2 absolute bottom-10 right-10 z-0 text-4xl text-center text-white dark:bg-nred' newContent={ <LocalListener />} />
    //     <div className="absolute bottom-0 w-10/12 bg-white z-10 stick-sensor-table">
    //       <div className="flex justify-around">
    //         <button className='table-arrow-class text-3xl' id="table-arrow" onClick={changeTableDisplay}>^</button>
    //       </div>
    //       <div id='sensorTableId' className="sensor-table overflow-hidden">
    //         <h2>{shipsconfig?.instruments[0]?.sensors[0].parameters[0].id}</h2>
    //         <FlexibleTable headers={tableHeaders} rows={tableRows} sticky={true} amount={5} />
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}


